module.exports = __webpack_public_path__ + "static/img/dragonVR.2d9f416e.png";